import React from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwFrames = () => {
  const sections = [
    {
      heading: "Single Frame Handling",
      ui: (
        <div className={styles.frameWrapper}>
          <iframe
            title="SingleFrame"
            className={styles.demoFrame}
            srcDoc={`
              <html>
                <body style="text-align:center; padding:40px;">
                  <h2>ENTER YOUR NAME</h2>
                  <input placeholder="Type your name here" />
                  <br/><br/>
                  <button style="padding:10px 20px; background:green; color:white;">Submit</button>
                </body>
              </html>
            `}
          />
        </div>
      ),
      code: `// Switch to single frame
const frame = page.frameLocator('iframe');

// Fill input inside frame
await frame.locator('input').fill('Logesh');

// Click button inside frame
await frame.locator('button').click();`
    },
    {
      heading: "Nested Frame Handling",
      ui: (
        <div className={styles.frameWrapper}>
          <iframe
            title="OuterFrame"
            className={styles.demoFrame}
            srcDoc={`
              <html>
                <body style="text-align:center; padding:30px;">
                  <h3>Outer Frame</h3>

                  <iframe 
                    srcdoc="
                      <html>
                        <body style='text-align:center; padding:30px;'>
                          <h2>ENTER USERNAME</h2>
                          <input placeholder='Your name here' />
                          <br/><br/>
                          <button style='padding:10px 20px; background:purple; color:white;'>Submit</button>
                        </body>
                      </html>
                    "
                    style="width:100%; height:200px; border:1px solid #ccc;">
                  </iframe>

                </body>
              </html>
            `}
          />
        </div>
      ),
      code: `// Handle nested frame
const outerFrame = page.frameLocator('iframe');

// Locate inner frame inside outer
const innerFrame = outerFrame.frameLocator('iframe');

// Fill nested input
await innerFrame.locator('input').fill('Admin');

// Click nested button
await innerFrame.locator('button').click();`
    }
  ];

  return <PlaywrightTemplate title="FRAMES" sections={sections} />;
};

export default PwFrames;